export const itemTypeIcons = Object.freeze({
  part: 'fas fa-tools',
  labor: 'far fa-user-hard-hat',
  tire: 'fas fa-tire',
  hazmatFee: 'fal fa-usd-circle',
  other: 'fal fa-list-alt',
  tireStorage: 'fal fa-inventory',
  discount: 'fal fa-badge-percent',
  bundle: 'fal fa-box',
  partLookUp: 'fal fa-box',
  sublet: 'fal fa-car'
});

export const subItemTypeIcons = Object.freeze({
  part: 'far fa-tools',
  labor: 'far fa-user-hard-hat',
  tire: 'far fa-tire',
  hazmatFee: 'fal fa-usd-circle',
  other: 'far fa-list-alt',
  sublet: 'far fa-car'
});

export const itemTypeLabel = Object.freeze({
  partLookUp: 'Part',
  part: 'Part',
  labor: 'Labor',
  tire: 'Tire',
  other: 'Other',
  hazmatFee: 'Fees',
  tireStorage: 'Tire storage',
  discount: 'Discount',
  bundle: 'Flat rate',
  roLevelFee: 'RO level fee',
  sublet: 'Sublet',
  passThroughTax: 'Passthrough Tax',
});

export const itemTypeLabelFR = Object.freeze({
  partLookUp: 'Pièces',
  part: 'Pièce',
  labor: 'Travail',
  tire: 'Pneu',
  other: 'Autre',
  hazmatFee: 'Frais',
  tireStorage: 'Stockage de pneus',
  discount: 'Remise',
  bundle: 'Forfait',
  roLevelFee: 'Frais de niveau RO',
  sublet: 'Sous-traitance',
  passThroughTax: 'Taxe de transfert',
});

export const itemCreateLabel = Object.freeze({
  part: '+ Add new part',
  labor: '+ Add new labor',
  tire: '+ Add new tire',
  other: '',
  hazmatFee: '+ Add new fees',
  tireStorage: '',
  discount: '+ Add new discount',
  bundle: '+ Add new flat rate',
  partLookUp: 'Enter part name',
});

export const itemTypePlaceholder = Object.freeze({
  part: 'Enter part name *',
  labor: 'Enter labor name *',
  tire: 'Enter tire name *',
  other: 'Enter name *',
  sublet: 'Enter name *',
  hazmatFee: 'Enter fee name *',
  tireStorage: 'Enter tire storage name *',
  discount: 'Enter discount name *',
  bundle: 'Enter flat rate name *',
  partLookUp: 'Select Part Type*',
  '': 'Enter name*',
});

export const SubTypePlaceholder = Object.freeze({
  part: 'Sub Part Category',
  labor: 'Sub Labor Category',
  tire: 'Sub Tire Category',
  hazmatFee: 'Sub Fee Category',
  discount: 'Sub Discount Category',
  '': 'Enter Subcategory name',
});

export const TypePlaceholder = Object.freeze({
  part: 'Part Category',
  labor: 'Labor Category',
  tire: 'Tire Category',
  hazmatFee: 'Fee Category',
  discount: 'Discount Category',
  '': 'Enter Category name',
});

export const SubSubTypePlaceholder = Object.freeze({
  part: 'Sub Part Item Type',
  labor: 'Sub Labor Item Type',
  tire: 'Sub Tire Item Type',
  hazmatFee: 'Sub Fee Item Type',
  discount: 'Sub Discount Item Type',
  '': 'Enter Subcategory name',
});

